module.exports = __webpack_public_path__ + "img/squad-earn.3634a738.svg";